import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import {required} from '@vuelidate/validators';

export default class PriceIndexData extends BaseModel {
  constructor(id, number, designation, indexDate, indexValue) {
    super(id, number, designation);
    this.indexDate = indexDate;
    this.indexValue = indexValue;
  }
  static get fkName() {
    return null;
  }
  static get apiRoute() {
    return 'standard_index_data';
  }
  static get listPageRoute() {
    return null;
  }
  static get detailPageRoute() {
    return null;
  }
  static get createInitColumns() {
    return {};
  }
  static get orderKey() {
    return 'index_date';
  }
  get fkName() {
    return PriceIndexData.fkName;
  }
  get apiRoute() {
    return PriceIndexData.apiRoute;
  }
  get detailPageRoute() {
    return PriceIndexData.detailPageRoute;
  }
  get listPageRoute() {
    return PriceIndexData.listPageRoute;
  }
  get createInitColumns() {
    return PriceIndexData.createInitColumns;
  }

  static get listDisplayAttrs() {
    return this.getAttributes(['indexDate', 'indexValue']);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['indexDate', 'indexValue']);
  }

  static get allAttributes() {
    return [
      new AT.DateAttribute({
        name: 'indexDate',
        column: 'index_date',
        validations: {required},
        tableProperties: {
          header: 'hit-app.standard-index.index-date',
          maxWidth: '1fr',
        },
      }),
      new AT.DecimalAttribute({
        name: 'indexValue',
        column: 'value',
        validations: {required},
        decimalPrecision: 4,
        creationValue: 0,
        tableProperties: {
          header: 'hit-app.standard-index.index-value',
          maxWidth: '1fr',
        },
      }),
    ];
  }
}
